import React from "react";
import { Route,Redirect,withRouter } from "react-router-dom";

const Authmiddleware = ({
	component: Component,
	layout: Layout,
	isMobile : isMobile,
	...rest
}) => (
		<Route {...rest}
			render={props => {
				if (!localStorage.getItem("token")) {
					return (
						<Redirect to={{ pathname: "/login", state: { from: props.location } }} />
					);
				}
			    return (
		     	<Layout>
					
					<Component  {...props} isMobile={isMobile}/>
				</Layout>
				);
			}}
		/>
	);

export default withRouter(Authmiddleware);

